// @flow
import type { Action } from '../actions/layout';

const initialState = {
  hadResumeDatabaseAd: false,
  hideSalarySurveyAd: false,
  withSearchHero: true
};

export type State = {
  withSearchHero: boolean
};

export default function layout(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'SET_WITH_SEARCH_HERO':
      return {
        ...state,
        withSearchHero: action.payload.withSearchHero
      };
    case 'SET_HIDE_SALARY_SURVEY_AD':
      return {
        ...state,
        hideSalarySurveyAd: action.payload.hideSalarySurveyAd
      };
    case 'SET_HAD_RESUME_DATABASE_AD':
      return {
        ...state,
        hadResumeDatabaseAd: action.payload.hadResumeDatabaseAd
      };
    default:
      return state;
  }
}
